// @ts-check

import React from 'react';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Paper from '@material-ui/core/Paper'
import useFormStyles from '../../common/FormStyle';
import HouseRow from './unitTypesHelpers/HouseRow';

export const HouseUnitTypes = () => {
  const formStyles = useFormStyles();
  const units = useSelector(state => state.globalFormData.buildingInfo.units);
  let unit_types = useSelector(state => state.globalFormData.buildingInfo.unit_types);
  const validationState = useSelector(state => state.globalFormData.validation);

  const floor_area_error = () => {
    if (units === 'm') {
      return validationState.floor_area.errText
    } else {
      return validationState.floor_area.errTextFt
    }
  }
  const house_width_error = () => {
    if (units === 'm') {
      return validationState.house_width.errText
    } else {
      return validationState.house_width.errTextFt
    }
  }
  return (
    <Box marginY={2}>
      <TableContainer className={formStyles.unitsTableContainer} component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={[formStyles.unitsTableCell, formStyles.colorColumn].join(" ")}></TableCell>
              <TableCell className={[formStyles.unitsTableCell, formStyles.unitTypeEditSmallColumn].join(" ")} >Unit type</TableCell>
              <TableCell className={[formStyles.unitsTableCell, formStyles.floorAreaSmallColumn].join(" ")}>{`Floor area(${units}²)`}</TableCell>
              <TableCell className={[formStyles.unitsTableCell, formStyles.storeysColumn].join(" ")}>Storeys</TableCell>
              <TableCell className={[formStyles.unitsTableCell, formStyles.houseWidthColumn].join(" ")}>{`Width(${units})`}</TableCell>
              <TableCell className={formStyles.unitsTableCell}> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {unit_types.map((unitType, index) => (
              <HouseRow unitType={unitType} index={index} key={index} />
            ))}
          </TableBody>
        </Table>
        {
          !validationState.floor_area.valid &&
          <Typography style={{ color: 'Red' }}>
            {floor_area_error()}
          </Typography>
        }
        {
          !validationState.storeys.valid &&
          <Typography style={{ color: 'Red' }}>
            {validationState.storeys.errText}
          </Typography>
        }
        {
          !validationState.house_width.valid &&
          <Typography style={{ color: 'Red' }}>
            {house_width_error()}
          </Typography>
        }
        {
          !validationState.unit_type.valid &&
          <Typography style={{ color: 'Red' }}>
            {validationState.unit_type.errText}
          </Typography>
        }

        {
          !validationState.unique_floor_area?.valid &&
          <Typography style={{ color: 'Red' }}>
            {validationState.unique_floor_area?.errText}
          </Typography>
        }
        {
          !validationState.unique_unit_type?.valid &&
          <Typography style={{ color: 'Red' }}>
            {validationState.unique_unit_type?.errText}
          </Typography>
        }

      </TableContainer>
    </Box>
  )
}